/** Liste des langues disponible sur Dcx */
enum LanguageEnum {
    None = 0,
    French = 1,
    English = 2,
}

export default LanguageEnum;